import { observer } from "mobx-react";

import { ActivitiesCalculator } from "../componentsCalculatorStep/ActivitiesCalculator/ActivitiesCalculator";
import ModeSelection from "../componentsCalculatorStep/ModeSelection/ModeSelection";
import BotsCalculator from "../componentsCalculatorStep/CalculatorStep/BotsCalculator/BotsCalculator";
import HumansCalculator from "../componentsCalculatorStep/CalculatorStep/HumansCalculator/HumansCalculator";
import Recommendation from "../componentsCalculatorStep/Recommendation/Recommendation";
import Faqed from "components/UI/Faqed/Faqed";
import { Notice } from "../componentsCalculatorStep/Notice/Notice";
import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import Icon from "components/UI/IconSVG/Icon";
import DeadlineSelector from "../componentsCalculatorStep/DeadlineSelector/DeadlineSelector";
import RadioSelector from "../componentsCalculatorStep/RadioSelector/RadioSelector";
import AiAgentSelection from "../componentsCalculatorStep/AiAgentSelection/AiAgentSelection";

import { getPeopleWord, isListenersPage } from "utils/helpers";
import upDoubleArrow from "assets/images/upDoubleArrow.svg";

import "./IsDesktopCalculatorStep.scss";

export const IsDesktopCalculatorStep = observer(
  ({
    store,
    bots = false,
    calculator,
    pathname,
    linkRef,
    reviewRef,
    commentRef,
    getDisplayCount,
    getAllActionCount,
    onClickNext,
    showRecommendation,
    currentCalculatorPrice,
    isTestPackageSelected,
    titleModeSelection,
    descriptionModeSelection,
    isMobile
  }) => {    
    const { market, mode } = calculator;
    const notice = mode.notice;
    const isReviewsMode = mode.id === 'reviews';
    const isListeners = isListenersPage(pathname);
    const currentExecutorType = market.executorTypes?.length > 0 ? market.executorTypes[store.calculators.indexOf(calculator) % market.executorTypes.length] : null;
    const showAiAgentSelection = market.aiAgents && market.aiAgents.length > 0;

    return (
      <div className="market-step2">
        <div className="market-step2__distribution">
          <Faqed text={mode.stepTwoTitleFaq}>
            <Icon className="market-step2__distribution-icon" name={market.icon} />
            <p className="market-step2__distribution-title">{mode.calculatorTitle}</p>
          </Faqed>
          {currentExecutorType?.description && <div className="market-step2__executor-info">{currentExecutorType.description}</div>}
          {!market.executorTypes && store.calculators.filter(calculator => !!calculator.mode.bots === bots).length > 1 && <ModeSelection store={store} bots={bots} title={titleModeSelection} />}
          {!market.executorTypes && market.isSeo && store.calculators.length > 1 && <ModeSelection store={store} title={titleModeSelection} description={descriptionModeSelection} />}
          {showAiAgentSelection && <AiAgentSelection store={store} market={market} />}
          <ActivitiesCalculator store={store} linkRef={linkRef} reviewRef={reviewRef} commentRef={commentRef} />
          {mode.bots && <Recommendation market={market} isReviewsMode={isReviewsMode} isEditGrayVisible={false} hasBots={mode.bots} />}
        </div>

        <div className="market-step2__settings">  
          <div className="market-step2__settings-container">
            {mode.bots
              ? (!calculator.store.testing && <BotsCalculator store={store} modeBots={mode.bots} currentCalculatorPrice={currentCalculatorPrice} isTestPackageSelected={isTestPackageSelected} isMobile={isMobile} />)
              : <HumansCalculator store={store} mode={mode} pathname={pathname} currentCalculatorPrice={currentCalculatorPrice} showRecommendation={showRecommendation} getDisplayCount={getDisplayCount} getAllActionCount={getAllActionCount} isListeners={isListeners} isMobile={isMobile} />
            }
            {mode.bots && <RadioSelector store={store} />}
            <DeadlineSelector store={store}   title={`Выберите срок рассылки заданий ${getPeopleWord(pathname, 'accusative')}м:`} isTestPackageSelected={isTestPackageSelected} isMobile={isMobile} />
            {!showAiAgentSelection && !mode.bots && (isReviewsMode 
              ? <Recommendation market={market} isReviewsMode={isReviewsMode} isEditGrayVisible={true} />
              : showRecommendation && <Recommendation market={market} isReviewsMode={isReviewsMode} isEditGrayVisible={true} />
            )}
            <ButtonWithIcon className="market-step2__create-button" title="Следующий шаг" icon={upDoubleArrow} onClick={onClickNext} />
          </div>

          {!mode.bots && !showRecommendation && <Notice notice={notice} />}
        </div>
      </div>
    );
  }
);
